import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { getCookie } from '../../utilities';
import SessionManager from '../common/SessionManager';

function ProtectedRoute() {
  const { loggedIn } = useAppSelector((state) => state?.auth);
  const token = getCookie('_tk');
  const location = useLocation();

  if (!loggedIn && !token) {
    return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
  }

  return (
    <>
      <SessionManager />
      <Outlet />
    </>
  );
}

export default ProtectedRoute;
